import { render, staticRenderFns } from "./BacklogQueue.vue?vue&type=template&id=55657a58&scoped=true&"
import script from "./BacklogQueue.vue?vue&type=script&lang=js&"
export * from "./BacklogQueue.vue?vue&type=script&lang=js&"
import style0 from "./BacklogQueue.vue?vue&type=style&index=0&id=55657a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55657a58",
  null
  
)

export default component.exports